import React from 'react'
import './PageNumberBar.scss'

const PageNumberBar = ({
  pageNumbersToShow,
  activePageNum,
  setActivePageNum,
  additionalClickHandler,
}) => (
  <div className="PageNumberBar">
    {pageNumbersToShow.map((pageNumber) => (
      <button
        type="button"
        key={pageNumber}
        className={activePageNum === pageNumber ? 'active' : ''}
        onClick={() => {
          setActivePageNum(pageNumber)
          if (additionalClickHandler) additionalClickHandler(pageNumber)
        }}
      >
        &nbsp;{pageNumber}&nbsp;
      </button>
    ))}
  </div>
)

export default PageNumberBar
